export default __webpack_public_path__ + "static/media/Gloria Iyalla.89350b91.jpg";